<script>
import ListingModel from "@/views/WorkerBalance/Components/ListingModel.vue";

export default {
    name: "WorkerBalanceVacation",
    components: {ListingModel}

};
</script>

<template>
    <listing-model
        vacation
        root-path="vacation_balance"
    />
</template>
